import { tw } from '@/utils/tw';
import ScrollArticleLabelTheme from 'base/components/ScrollArticleLabel/theme';

const ScrollArticleLabel = tw.theme({
  extend: ScrollArticleLabelTheme,
  base: `text-headline-2xs sm:text-headline-xs`,
});

export default ScrollArticleLabel;
